export default __webpack_public_path__ + "static/media/ic_plus.65a4b36c.svg";